// extracted by mini-css-extract-plugin
module.exports = {"returnSummary":"returnSummary_returnSummary__KaXed"};